import React, { useEffect, useState } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
// import ReactPWAInstallProvider, { useReactPWAInstall } from "react-pwa-install";
import { Divider, Button } from "@material-ui/core";

// pages
import Main from "../../pages/Main/Main";
import Sar from "../../pages/Sar/Sar";
import Pollution from "../../pages/Pollution/Pollution";
import Sign from "../../pages/Sign/Sign";
// components
import Header from "../Header";
// styles
import useStyles from "./styles";

function Layout(props) {
  var classes = useStyles();
  // const [install, setInstall] = useState(false);
  // const [deferredPrompt, setDeferredPrompt] = useState(null);
  // useEffect(() => {
  //   if (
  //     window.matchMedia("(display-mode: standalone)").matches ||
  //     window.navigator.standalone === true
  //   ) {
  //     // hidden the button
  //     setInstall(false);
  //   }
  //   window.addEventListener("beforeinstallprompt", (e) => {
  //     // this event does not fire if the application is already installed
  //     // then your button still hidden ;)

  //     // show button with display:block;
  //     setInstall(true);

  //     // prevent default event
  //     e.preventDefault();

  //     // store install avaliable event
  //     setDeferredPrompt(e);
  //     console.log(e)
  //   });
  //   window.addEventListener("appinstalled", (e) => {
  //     alert("success app install!");
  //   });
  // }, []);

  // const installHandle = () => {
  //   deferredPrompt.prompt();
  //   deferredPrompt.userChoice.then((choiceResult) => {
  //     if (choiceResult.outcome === "accepted") {
  //       // user accept the prompt

  //       // lets hidden button
  //       setInstall(false);
  //     } else {
  //       console.log("User dismissed the prompt");
  //     }
  //     setDeferredPrompt(null);
  //   });
  // };

  return (
    <div className={classes.root}>
      <Header history={props.history} />
      <div className={classes.content}>
        <Switch>
          <Route exact path="/app/main" component={Main} />
          <Route exact path="/app/SAR" component={Sar} />
          <Route exact path="/app/pollution" component={Pollution} />
          <Route exact path="/app/sign" component={Sign} />
        </Switch>
      </div>
      {/* {install ? (
        <div className={classes.installAppBack}>
          <div className={classes.installAppContainer}>
            <div className={classes.installAppTitle}>Install App</div>
            <Divider variant="middle" />
            <div className={classes.installAppAction}>
              <div>
                <Button variant="contained" onClick={() => setInstall(false)}>
                  Cancel
                </Button>
              </div>
              <div>
                <Button
                  onClick={installHandle}
                  variant="contained"
                  color="primary"
                >
                  Install
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : null} */}
    </div>
  );
}

export default withRouter(Layout);
